// Conversietracking op Formie, overgenomen uit base-craft (commit eede152 van Robin).
// Het event zet `modules/formtracking` nu aan de serverkant, want
// `onAfterFormieSubmit` vuurt niet bij page-reload. Wat hier overblijft: een
// AJAX-formulier zonder redirect, dat op de pagina blijft en dus geen volgende
// pagina heeft waar de flash uitgelezen wordt.

function initConversieTracking(root = document) {
    root.querySelectorAll("form[data-fui-form]").forEach((form) => {
        if (form.dataset.conversieInit) return;
        form.dataset.conversieInit = "1";

        form.addEventListener("onAfterFormieSubmit", (event) => {
            const detail = event.detail || {};

            // Tussenstap van een formulier over meerdere pagina's is nog geen conversie.
            if (detail.nextPageId) return;

            // Met een redirect pusht de volgende pagina het event, uit de flash.
            if (detail.redirectUrl) return;

            // Titels uit de wikkel rond het formulier, zie `_components/link.twig`.
            const context = form.closest("[data-conversie-form-naam]");

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: "form_submit",
                form: form.getAttribute("data-form-handle") || null,
                form_naam: context?.dataset.conversieFormNaam || null,
                pagina: context?.dataset.conversiePagina || null,
                pagina_pad: window.location.pathname.replace(/\/+$/, "") || "/",
            });
        });
    });
}

document.addEventListener("DOMContentLoaded", () => initConversieTracking());
